import React, { useEffect } from 'react';
import {
	HealthPlanUser,
	useHealthPlanUserQuery, useLazyHealthPlanUserQuery
} from '../../../../graphql/graphql';
import HealthPlanWrapperContainer, {
	HealthPlanWrapperContainerProps,
} from '../../../../Components/HealthPlan/HealthPlanWrapper/HealthPlanWrapperContainer';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import Loading from '../../../../Components/Loading';

interface Props extends HealthPlanWrapperContainerProps {
	healthPlanCode: string;
	patientId: string;
}

const HealthPlanLoader: React.FC<Props> = props => {
	const { setHealthPlanUser } = useHealthPlanContext();

	//LOADING HEALTH PLAN USER
	const [load, {data, isLoading}] = useLazyHealthPlanUserQuery();

	//SETTING HEALTH PLAN USER IN HEALTH PLAN CONTEXT
	useEffect(() => {
		if (data?.healthPlanUser) {
			setHealthPlanUser(data?.healthPlanUser as HealthPlanUser);
		}
	}, [data]);

	useEffect(() => {
		load({
			userId: props.patientId,
			healthPlanCode: props.healthPlanCode,
		})
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	if (!data?.healthPlanUser) {
		return <></>;
	}

	return (
		<HealthPlanWrapperContainer
			{...props}
			healthPlanUser={data?.healthPlanUser as HealthPlanUser}
		/>
	);
};

export default HealthPlanLoader;
